// Which body a warp frame that crossed two capture spheres names.
//
// A frame under warp is a segment, and its two ends can be measured against
// two different bodies: the one dominant at the segment's END, and the one
// dominant at its START. A frame fast enough to cross one capture sphere is
// often fast enough to change dominance as it does, so both sweeps can read a
// crossing on the SAME frame - and the drop then has to name one of them.
//
// It is a module of its own because it is the one piece of the drop a check
// can read without a browser: `tools/preview/warp-drop-check.mjs` imports it
// under Node's type stripping, with no page, no scene and no port. Nothing
// here imports anything, so that check carries no three.js and no DOM.

/** One swept crossing: the body, and how near the ship's segment came to it. */
export interface WarpDropCrossing {
  readonly id: string;
  readonly name: string;
  readonly minM: number;
}

/**
 * The crossing to name. `endFirst` is the ordering that shipped, where the
 * end sweep answers whenever it crossed at all, whatever the start sweep read.
 */
export function nearerWarpDrop(
  end: WarpDropCrossing | null,
  prev: WarpDropCrossing | null,
  endFirst: boolean,
): WarpDropCrossing | null {
  if (end === null) return prev;
  if (prev === null) return end;
  if (endFirst) return end;
  // Minima to two different centres: the nearer pass is the one the pilot flew
  // through, and a tie goes to the end body, the frame the notice is drawn in.
  return prev.minM < end.minM ? prev : end;
}
